export const createHopMovement = (scene, player) => {
    const hopDistance = 32;
    const hopDuration = 400;
    const hopHeight = 16;
  
    const movements = {
      'n':  { x: 0, y: -1 },
      'ne': { x: 0.707, y: -0.707 },
      'e':  { x: 1, y: 0 },
      'se': { x: 0.707, y: 0.707 },
      's':  { x: 0, y: 1 },
      'sw': { x: -0.707, y: 0.707 },
      'w':  { x: -1, y: 0 },
      'nw': { x: -0.707, y: -0.707 }
    };
  
    const oppositeDirections = {
      'n': 's',
      'ne': 'sw',
      'e': 'w',
      'se': 'nw',
      's': 'n',
      'sw': 'ne',
      'w': 'e',
      'nw': 'se'
    };
  
    let isHopping = false;
    let currentTween = null;
  
    const isInBounds = (x, y) => {
      const bounds = scene.movementBounds;
      return x >= bounds.x && x <= bounds.x + bounds.width &&
             y >= bounds.y && y <= bounds.y + bounds.height;
    };
  
    return (direction) => {
      if (isHopping) return;
  
      const move = movements[direction];
      const targetX = player.x + (hopDistance * move.x);
      const targetY = player.y + (hopDistance * move.y);
      
      if (!isInBounds(targetX, targetY)) {
        return false;
      }
  
      isHopping = true;
      const startY = player.y;
  
      currentTween = scene.tweens.add({
        targets: player,
        x: targetX,
        y: targetY,
        duration: hopDuration,
        ease: 'Quad.easeOut',
        onUpdate: (tween) => {
          const progress = tween.progress;
          const heightOffset = Math.sin(progress * Math.PI) * hopHeight;
          player.y = Phaser.Math.Linear(startY, targetY, progress) - heightOffset;
        },
        onComplete: () => {
          isHopping = false;
          if (player.playColorAnimation) {
            player.playColorAnimation("idle2", true);
          } else if (scene.playerColor) {
            player.play(`${scene.playerColor}_idle2`, true);
          }
          player.setScale(1);
        }
      });
  
      scene.tweens.add({
        targets: player,
        scaleY: 0.8,
        duration: hopDuration / 4,
        yoyo: true,
        repeat: 1
      });
    };
  };